<template>
  <a :href="'/property-detail/' + propertyValue.slug" >
  <div class="card__property">
    
    <div class="card__content">
     
        <div class="content__tags">
          <span v-show="propertyValue.isFeatured" class="featured__tag">Featured</span>
          <span v-show="propertyValue.isNewListening" class="new__tag">New Listing</span>
        </div>
        <div class="content__info">
          <div class="info__property">
            <div class="property__stats">
              <div class="stat stat__irr">{{ formatNumber(propertyValue.irr) }}<span>%</span> TIR</div>
              <div class="stat stat__cap">{{ formatNumber(propertyValue.coc) }}<span>%</span> CoC</div>
            </div>
            <div class="property__address">
              <span class="address__1">{{ propertyValue.title }}</span>
              <span class="address__2">{{ propertyValue.add }}</span>
            </div>
          </div>
          <button v-show="true" class="card__btn"><!-- Available 2,149 tokens at $50 --></button> 
        </div>
      
    </div>
    <div class="overlay"></div>
    <img class="card__background" :src="this.propertyValue.img" />
  </div>
</a>
</template>
<script>
import numeral from "numeral"

export default {
  name: 'CardIgtem',
  props: {
    property: {
      type: Object,
      required: true,
      default:{}
    }
  },
  data () {
    return {
      propertyValue: {
        img: '',
        title: '',
        subtitle: '',
        description: '',
        irr:'',
        coc:'',
        add:'',
        tokenPrice: null,
        capRate: null,
        projAppreciation: null,
        projIRR: null,
        tokenSold: false,
        isFeatured: false,
        isNewListening: null,
      }
    }
  },
  mounted(){
    console.log("propiedad",this.property )
    if(this.property.attributes.Images.data[0].attributes.formats.medium) {
      this.propertyValue.img = this.property.attributes.Images.data[0].attributes.formats.medium.url
    }
    else if(this.property.attributes.Images.data[0].attributes.formats.small) {
      this.propertyValue.img = this.property.attributes.Images.data[0].attributes.formats.small.url
    }
    else {
      this.propertyValue.img = this.property.attributes.Images.data[0].attributes.url
    }

    let financialData = this.property.attributes.property_financial.data.attributes
    this.propertyValue.irr = financialData.IRR
    this.propertyValue.coc = financialData.Coc
    
    this.propertyValue.title = this.property.attributes.Name
    this.propertyValue.add = this.property.attributes.Address
    this.propertyValue.tokenPrice = this.property.attributes.tokenPrice
    this.propertyValue.capRate = this.property.attributes.capRate
    this.propertyValue.projAppreciation = this.property.attributes.projAppreciation
    this.propertyValue.projIRR = this.property.attributes.projIRR
    this.propertyValue.tokenSold = this.property.attributes.tokenSold
    this.propertyValue.isFeatured = this.property.attributes.isFeatured
    this.propertyValue.isNewListening = this.property.attributes.isNewListening
    this.propertyValue.slug = this.property.attributes.slug
 
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0.0")
    }
  }
}
</script>
<style lang="scss">
.card__property {
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  min-height: 360px;
  position: relative;
  display: flex;
  .card__background {
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    z-index: 0;
    top: 0;
    left: 0;
  }
  .overlay {
    z-index: 1;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 75%;
    background: rgb(13,5,26);
    background: linear-gradient(180deg, rgba(13,5,26,0) 0%, rgba(13,5,26,1) 100%);
  }
  .card__content {
    flex: 1;
    z-index: 10;
    padding: 8px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .featured__tag {
      background-color: #3A2E85;
      border-radius: 2px;
      padding: 4px 12px;
      text-transform: uppercase;
      font-size: 12px;
      line-height: 18px;
      color: white;
    }
    .new__tag {
      background-color: #35146735;
      border-radius: 2px;
      padding: 4px 12px;
      font-size: 12px;
      line-height: 18px;
      color: white;
    }

    .content__info {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .card__btn {
      all: unset;
      font-family: 'Roboto', sans-serif;
      font-weight: 400;
      display: block;
      background-color: rgba(255, 255, 255, 10%);
      padding: 10px 16px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 20px;
      color: #CAEEDD;
    }

    .info__property {
      display: flex;
      gap: 16px;
    }

    .property__stats {
      display: flex;
      flex-direction: column;
      width: 92px;
      flex-shrink: 0;

      .stat {
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        padding-left: 20px;
        padding-right: 0px;
        padding-top: 4px;
        padding-bottom: 4px;

        span {
          font-family: 'Roboto', sans-serif;
          font-size: 12px;
          font-weight: 400;
          position: relative;
          top: 3px;
        }

        &::before {
          content: "";
          border-bottom: 14px solid rgba(0,0,0,0);
          border-top: 16px solid rgba(0,0,0,0);
          right: 0;
          margin-right: -8px;
          position: absolute;
          top: 0px;
          width: 0px;
          height: 100%;
        }

        &.stat__irr {
          background-color: #3A2E85;
          color: white;
          position: relative;
          &::before {
            border-left: 9px solid #3b2e85;
          }
        }

        &.stat__cap {
          background-color: #D6FFFF;
          color: #351467;
          font-size: 14px;
          position: relative;
          &::before {
            border-left: 9px solid #D6FFFF;
          }
        }
      }
    }

    .property__address {
      display: flex;
      flex: 1;
      width: 100%;
      flex-direction: column;

      .address__1 {
        font-family: 'Roboto', sans-serif;
        color: white;
        font-size: 14px;
        font-weight: 400;
      }

      .address__2 {
        font-family: 'Roboto', sans-serif;
        color: #CAEEDD;
        font-size: 10px;
        font-weight: 400;
      }
    }
  }
}
</style>